import { render, staticRenderFns } from "./sgplhc.vue?vue&type=template&id=bccb4b2a&scoped=true"
var script = {}
import style0 from "./sgplhc.vue?vue&type=style&index=0&id=bccb4b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccb4b2a",
  null
  
)

export default component.exports